// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@font-face{font-display:swap;font-family:\"Manrope\";font-weight:500;src:url(\"https://b.paymongocdn.com/fonts/Manrope/Manrope-VF.woff2\") format(\"woff2 supports variations\"),url(\"https://b.paymongocdn.com/fonts/Manrope/Manrope-VF.woff2\") format(\"woff2-variations\"),url(\"https://b.paymongocdn.com/fonts/Manrope/Manrope-Medium.woff2\") format(\"woff2\")}@font-face{font-display:swap;font-family:\"Manrope\";font-weight:600;src:url(\"https://b.paymongocdn.com/fonts/Manrope/Manrope-VF.woff2\") format(\"woff2 supports variations\"),url(\"https://b.paymongocdn.com/fonts/Manrope/Manrope-VF.woff2\") format(\"woff2-variations\"),url(\"https://b.paymongocdn.com/fonts/Manrope/Manrope-SemiBold.woff2\") format(\"woff2\")}.Toggle{background-color:#a0a9b9;border:0;border-radius:6px;box-shadow:none;cursor:pointer;min-height:24px;overflow:hidden;padding:0;position:relative;-webkit-border-radius:3px;-moz-border-radius:3px;border-radius:3px}.Toggle::before{box-shadow:inset 0px 0px 2px rgba(0,0,0,.25);content:\"\";display:block;height:100%;left:0;position:absolute;top:0;transition:opacity .15s ease-in-out;width:100%}.Toggle:hover{background-color:#7c8595}.Toggle:focus{box-shadow:0 0 0 1px #afbbca}.Toggle:disabled{cursor:not-allowed}.Toggle .button__content{color:#f9fafb;display:block}.Toggle .button__content>div{align-items:center;display:flex;justify-content:space-between}.Toggle .button__content>div>div{-webkit-transition:margin .36s cubic-bezier(0.78, 0.14, 0.15, 0.86);-moz-transition:margin .36s cubic-bezier(0.78, 0.14, 0.15, 0.86);-ms-transition:margin .36s cubic-bezier(0.78, 0.14, 0.15, 0.86);-o-transition:margin .36s cubic-bezier(0.78, 0.14, 0.15, 0.86);transition:margin .36s cubic-bezier(0.78, 0.14, 0.15, 0.86);line-height:16px;text-align:center}.Toggle .button__content>div>div.onLabel{margin-left:-100%;padding-left:.25rem;padding-right:1.5rem}.Toggle .button__content>div>div.checked{margin-left:0px}.Toggle .button__content>div>div.offLabel{margin-right:-100%;padding-left:1.5rem;padding-right:.25rem}.Toggle .button__content>div>div.unchecked{margin-right:0px}.Toggle:after{background-color:#f9fafb;content:\" \";cursor:pointer;height:16px;left:4px;position:absolute;top:4px;width:16px;-webkit-border-radius:3px;-moz-border-radius:3px;border-radius:3px;-webkit-transition:all .36s cubic-bezier(0.78, 0.14, 0.15, 0.86);-moz-transition:all .36s cubic-bezier(0.78, 0.14, 0.15, 0.86);-ms-transition:all .36s cubic-bezier(0.78, 0.14, 0.15, 0.86);-o-transition:all .36s cubic-bezier(0.78, 0.14, 0.15, 0.86);transition:all .36s cubic-bezier(0.78, 0.14, 0.15, 0.86)}.Toggle.toggle-checked{background-color:#4a98e7}.Toggle.toggle-checked::before{opacity:0}.Toggle.toggle-checked:hover{background-color:#448ad9}.Toggle.toggle-checked:focus{box-shadow:0 0 0 1px #5ca6ea}.Toggle.toggle-checked:after{left:100%;margin-left:-3px;-webkit-transform:translateX(-100%);-moz-transform:translateX(-100%);-ms-transform:translateX(-100%);transform:translateX(-100%)}", ""]);
// Exports
exports.locals = {
	"color900-accent": "#3600cd",
	"color900-brand": "#145739",
	"color900-negative": "#bf1217",
	"color900-primary": "#2b4a94",
	"color900-shade": "#262e3a",
	"color900-warm": "#e54d03",
	"color800-accent": "#5400d3",
	"color800-brand": "#1f7454",
	"color800-negative": "#ce2024",
	"color800-primary": "#3667b4",
	"color800-shade": "#4c5564",
	"color800-warm": "#ee6802",
	"color700-accent": "#6400d8",
	"color700-brand": "#008651",
	"color700-negative": "#db282b",
	"color700-primary": "#3c78c6",
	"color700-shade": "#7c8595",
	"color700-warm": "#f57902",
	"color600-accent": "#7400e1",
	"color600-brand": "#00985d",
	"color600-negative": "#ed3331",
	"color600-primary": "#448ad9",
	"color600-shade": "#a0a9b9",
	"color600-warm": "#fb8901",
	"color500-accent": "#7f00e7",
	"color500-brand": "#31a27c",
	"color500-negative": "#fc3d31",
	"color500-primary": "#4a98e7",
	"color500-shade": "#afbbca",
	"color500-warm": "#ff9500",
	"color400-accent": "#9542ec",
	"color400-brand": "#37b47e",
	"color400-negative": "#f84f4c",
	"color400-primary": "#5ca6ea",
	"color400-shade": "#cdd3da",
	"color400-warm": "#ffa425",
	"color300-accent": "#a969f0",
	"color300-brand": "#61c194",
	"color300-negative": "#ed7171",
	"color300-primary": "#74b6ee",
	"color300-shade": "#d4dae3",
	"color300-warm": "#ffb54c",
	"color200-accent": "#c297f4",
	"color200-brand": "#91d2b2",
	"color200-negative": "#f59999",
	"color200-primary": "#99cbf3",
	"color200-shade": "#e1e5ea",
	"color200-warm": "#ffca7f",
	"color100-accent": "#dac1f8",
	"color100-brand": "#bce4d0",
	"color100-negative": "#ffcdd2",
	"color100-primary": "#bfdef8",
	"color100-shade": "#f9fafb",
	"color100-warm": "#ffdfb1",
	"color050-accent": "#f4edfd",
	"color050-brand": "#e6f5ed",
	"color050-negative": "#ffebed",
	"color050-primary": "#edf6fd",
	"color050-shade": "#fff",
	"color050-warm": "#fff5e5"
};
module.exports = exports;
